import { Box, Button, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ExportToExcel } from 'components/export/ExportToExcel';
import ImportFile from 'components/import';
import SearchImput from 'components/searchInput';
import { containerData } from 'configs/containerData';
import dayjs from 'dayjs';
import ExportToExcelFile from 'pages/reports/filter/exportToExcel';
import { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { BsCalendar2Date } from 'react-icons/bs';
import { CiImport } from 'react-icons/ci';
import { FiPlusCircle } from 'react-icons/fi';
import { IoClose } from 'react-icons/io5';
import { useLocation } from 'react-router-dom';
import RangeComponent from './dateRange';
import clx from './styles.module.scss';

type Props = {
  date?: any;
  apiData?: any;
  setDate?: any;
  setOpen?: any;
  open?: boolean;
  search?: string;
  range?: boolean;
  fileName?: string;
  expoLoad?: boolean;
  btnHidden?: boolean;
  exportLoad?: boolean;
  refetch?: () => void;
  expoHidden?: boolean;
  dateHidden?: boolean;
  btnClick?: () => void;
  searchHidden?: boolean;
  importHidden?: boolean;
  expoClick?: () => void;
  disableFuture?: boolean;
  children?: React.ReactElement;
  setSearch?: (e: string) => void;
  setReload?: (e: boolean) => void;
  exportFn?: () => Promise<any>;
};

export function GlobalContainer({
  date,
  open,
  search,
  setDate,
  refetch,
  setOpen,
  children,
  btnClick,
  fileName,
  expoLoad,
  setSearch,
  setReload,
  btnHidden,
  exportLoad,
  apiData = [],
  range = false,
  dateHidden = true,
  expoHidden = true,
  importHidden = true,
  searchHidden = true,
  disableFuture = false,
  exportFn,
}: Props) {
  const location = useLocation();
  const path = location.pathname.substring(1);
  const [dateModal, setDateModal] = useState<any>(null);

  const dateModalOpen = Boolean(dateModal);

  const openDateModal = (event: React.MouseEvent<HTMLButtonElement>) =>
    setDateModal(event.currentTarget);

  return (
    <Box className={clx.root}>
      {containerData
        .filter((j) => j.url === path)
        .map((i, id) => (
          <Box key={id} className={clx.wrapper}>
            <Box className={clx.leftSide}>
              <span>{i.icon}</span>
              <Typography variant='h5' className={clx.title}>
                {i.title}
              </Typography>
            </Box>

            <Box className={clx.rightSide}>
              {searchHidden && <SearchImput search={search} setSearch={setSearch} />}

              {exportFn ? (
                <ExportToExcelFile
                  exportFn={exportFn}
                  fileName={fileName || 'export'}
                  disabled={expoHidden}
                  iconOnly={true}
                />
              ) : (
                <ExportToExcel
                  expoHidden={expoHidden}
                  fileName={fileName}
                  apiData={apiData}
                  expoLoad={expoLoad}
                  setReload={setReload}
                // expoDisable={!exportLoad}
                />
              )}
              {!importHidden && (
                <CiImport
                  cursor={'pointer'}
                  size={35}
                  color='#005AA9'
                  onClick={() => setOpen(true)}
                />
              )}

              <Button
                endIcon={<FiPlusCircle size={18} />}
                onClick={btnClick}
                sx={{
                  display: btnHidden ? 'none' : 'flex',
                }}
                className={clx.addBtn}>
                {i?.addText}
              </Button>

              {dateHidden ? (
                ''
              ) : (
                <Box className={clx.picker}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format='DD/MM/YYYY'
                      slotProps={{
                        textField: { size: 'small' },
                      }}
                      value={dayjs(date)}
                      disableFuture={disableFuture}
                      onChange={(e: any) => setDate(dayjs(e).format('YYYY-MM-DD'))}
                      slots={{ openPickerIcon: BsCalendar2Date }}
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: 'none',
                        },
                      }}
                    />
                  </LocalizationProvider>
                  {date && (
                    <AiOutlineClose onClick={() => setDate('')} className={clx.pickerIcon} />
                  )}
                </Box>
              )}

              {range ? (
                <Button onClick={openDateModal} className={clx.dateButton}>
                  {date
                    ? `
                    ${date?.from && dayjs(date?.from).format('DD/MM/YYYY')} 
                    / 
                     ${date?.to && dayjs(date?.to).format('DD/MM/YYYY')}
                     `
                    : '__-__- ____ / __-__- ____'}

                  {date && (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        setDate(null);
                      }}
                      className={clx.dateClose}>
                      <IoClose />
                    </span>
                  )}
                </Button>
              ) : (
                ''
              )}
            </Box>
          </Box>
        ))}
      <Box>{children}</Box>

      {open && <ImportFile open={open} close={() => setOpen(false)} refetch={refetch} />}
      {dateModal && (
        <RangeComponent
          date={date}
          setDate={setDate}
          anchorEl={dateModal}
          open={dateModalOpen}
          close={() => setDateModal(false)}
        />
      )}
    </Box>
  );
}
